export class Shtibel {
    shtibelID: number;
    shtibelName: string;
}  